export default __webpack_public_path__ + "static/identity-mock-m3-b9665ddb64a4f3bee05d9370cfb79937.png";